import { render, staticRenderFns } from "./RegistrationArea.vue?vue&type=template&id=1918cba6"
import script from "./RegistrationArea.vue?vue&type=script&lang=js"
export * from "./RegistrationArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports